module.exports = __webpack_public_path__ + "i18n/es.01db5ac682bbc47cf8466dc0ed34f072.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 848
// module chunks = 60